/**
 * Created by Shiv Roy on 27/9/17.
 */

import { isEmptyObject } from "../../../actions/utilAction";

// Form validation
const validate = (values) => {
  const error = {};
  if (!values.email || values.email.trim() === '') {
    error.email = 'Please enter email address';
  }
  if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(values.email)) {
    error.email = 'Please enter a valid email address';
  }
  if (!values.newEmailAddress || values.newEmailAddress.trim() === '') {
    error.newEmailAddress = 'Please enter email address';
  }
  if (values.newEmailAddress && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(values.newEmailAddress)) {
    error.newEmailAddress = 'Please enter a valid email address';
  }

  if (!values.phoneNumber || values.phoneNumber.trim() === '') {
    error.phoneNumber = 'Please enter phone number';
  }
  if (values.phoneNumber && values.phoneNumber.length < 14) {
    error.phoneNumber = 'Please enter valid phone number';
  }
  if (!values.firstName || values.firstName.trim() === '') {
    error.firstName = 'Please enter first name';
  }
  if (!values.address || values.address.trim() === '') {
    error.address = 'Please enter address';
  }
  if (!values.lastName || values.lastName.trim() === '') {
    error.lastName = 'Please enter last name';
  }
  if (!values.zip || values.zip.trim() === '') {
    error.zip = 'Please enter zip';
  }
  if (values.zip && values.zip.length < 5) {
    error.zip = 'Please enter correct zip';
  }
  if (!values.dob || values.dob.trim() === '') {
    error.dob = 'Please enter date of birth';
  }
  if (!values.doj || values.doj.trim() === '') {
    error.doj = 'Please enter hiring date';
  }
  if (!values.roleID) {
    error.roleID = 'Please enter role';
  }
  // if (values.npiNumber && (values.npiNumber || '').length < 10) {
  //   error.npiNumber = 'Please enter correct NPI number';
  // }
  if (!values.userName || values.userName.trim() === '') {
    error.userName = 'Please enter user name';
  }
  if (values.userName) {
    if (values.userName.trim().length < 5) {
      error.userName = 'Please enter minimum 5 characters';
    }
  }
  /*
  if (!values.MileageRate || values.MileageRate.trim() === '') {
    error.MileageRate = 'Please enter first name';
  }*/
  if (!values.newPassword || values.newPassword.trim() === '') {
    error.newPassword = 'Please enter password';
  } else if (!/^(?=.{8,30}$)/.test(values.newPassword)) {
    error.newPassword = 'Password should contain minimum 8 and maximum 30 characters';
  } else {
    let pError = [], prefix = '';
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\+\-\_\@\#\$\%\&\!\,\[\]\{\}\(\)\|])/.test(values.newPassword)) {
      prefix = 'Password should contain atleast ';
    }
    if (!/^(?=.*[a-z])/.test(values.newPassword)) {
      pError.push('1 lowercase character');
    }
    if (!/^(?=.*[A-Z])/.test(values.newPassword)) {
      pError.push('1 uppercase character');
    }
    if (!/^(?=.*[0-9])/.test(values.newPassword)) {
      pError.push('1 numeric value');
    }
    if (!/^(?=.*[\+\-\_\@\#\$\%\&\!\,\[\]\{\}\(\)\|])/.test(values.newPassword)) {
      pError.push('1 special character');
    }
    error.newPassword = prefix + pError.join(', ');
  }
  if (values.taxId) {
    var numberRegex = /^\d+$/;
    if (!numberRegex.test(values.taxId.trim())) {
      error.taxId = 'Please enter only numbers';
    }
    else if (values.taxId.trim().length < 9) {
      error.taxId = 'Please enter minimum 9 digits';
    }    
  }

  // if (!values.password || values.password.trim() === '') {
  //   error.password = 'Please enter password';
  // }
  // if (values.password) {
  //   if (values.password.trim().length < 8) {
  //     error.password = 'Please enter minimum 8 characters';
  //   }
  // }
  if (!values.confirmPassword || values.confirmPassword.trim() === '') {
    error.confirmPassword = 'Please enter confirm password';
  }
  if (values.confirmPassword && values.newPassword && values.confirmPassword !== values.newPassword) {
    error.confirmPassword = 'Password doesn\'t match';
  }

  if (!values.countryID) {
    error.countryID = 'Please select country';
  }
  if (!values.stateID || values.stateID === undefined) {
    error.stateID = 'Please select state';
  }
  if (!values.maritalStatus) {
    error.maritalStatus = 'Please select marital status';
  } else if (!Number.isInteger(values.maritalStatus)) {
    error.maritalStatus = 'Incorrect marital status';
  }

  if (!values.mileageRate) {
    error.mileageRate = 'Please select mileage rate';
  }/* else if (!Number.isInteger(values.Role)) {
    error.Role = 'Incorrect role';
  }*/

  if (!values.role) {
    error.role = 'Please select role';
  } else if (!Number.isInteger(values.role)) {
    error.role = 'Incorrect role';
  }

  // if (!values.payRate) {
  //   error.payRate = 'Please enter pay rate';
  // }
  if (!values.payrollGroupID) {
    error.payrollGroupID = 'Please select payroll group';
  }

  if (!values.staffLocationList || !values.staffLocationList.length) {
    error.staffLocationList = 'Please select location';
  }
  if (!values.defaultLocation) {
    error.defaultLocation = 'Please select default location';
  }

  if (values.npiNumber && values.npiNumber.length < 8) {
    error.npiNumber = 'Please enter valid NPI number';
  }

  if(values.staffLicenseOrCertificateModel && values.staffLicenseOrCertificateModel.length > 0){
    const cArrayErrors = [];
    
    values.staffLicenseOrCertificateModel.forEach((certificate,index) => {
      const cErrors = {};
      
      if(certificate !== undefined && certificate.LicenseOrCertificateName !==undefined ){

        if(!certificate.LicenseOrCertificateNumber || certificate.LicenseOrCertificateNumber == undefined){
          cErrors.LicenseOrCertificateNumber = "Please enter License Or Certificate Number"
        }
        
        if(!certificate.issueDate || certificate.issueDate == undefined){
          cErrors.issueDate = "Please enter Issue Date"
        }
        cArrayErrors[index] = cErrors;
      }
    });
    if(cArrayErrors.length){
      error.staffLicenseOrCertificateModel = cArrayErrors;
    }
  }

  // if (!values.TaxId) {
  //   error.TaxId = 'Please enter tax';
  // }
  /* else if (!Number.isInteger(values.TaxId)) {
    error.TaxId = 'Incorrect tax';
  }*/

  // if (!values.phone) {
  //   error.phone = 'Please enter phone';
  // }
  // if (values.phone && values.phone.length < 14) {
  //   error.phone = 'Please enter valid phone';
  // }
  // staff availability validations
  // if (values.week && values.week.length) {

  //   let weekRowErrors = [];
  //   let weekColErrors = [];
  //   values.week.forEach((weekObj, rowIndex) => {
  //     const subObjErrors = {};
  //     weekObj.forEach((subObj, colIndex) => {
  //       if (!subObj.StartTime) {
  //         subObjErrors.StartTime = 'Please enter start time';
  //         weekColErrors[colIndex] = subObjErrors;
  //       }
  //       if (!subObj.EndTime) {
  //         subObjErrors.EndTime = 'Please enter end time';
  //         weekColErrors[colIndex] = subObjErrors;
  //       }
  //       return weekColErrors;
  //     });
  //     if (weekColErrors.length) {
  //       weekRowErrors[rowIndex] = weekColErrors;
  //     }
  //     if (weekRowErrors.length) {
  //       error.week = weekRowErrors;
  //       // console.log('weekRowErrors ->', weekRowErrors);
  //     }
  //   });

  // }
  if (values.availabilityData && values.availabilityData.length) {

    const availabilityDataArrayErrors = [];
    values.availabilityData.forEach((data, index) => {
      const availabilityDataErrors = {};
      // if (data.availabilityDate !== null && !data.availabilityStartTime) {
      //   availabilityDataErrors.availabilityStartTime = 'Please select start time';
      //   availabilityDataArrayErrors[index] = availabilityDataErrors;
      // }
      // if (data.availabilityDate !== null && !data.availabilityEndTime) {
      //   availabilityDataErrors.availabilityEndTime = 'Please select end time';
      //   availabilityDataArrayErrors[index] = availabilityDataErrors;
      // }
      // if (data.availabilityEndTime && data.availabilityStartTime && data.availabilityEndTime <= data.availabilityStartTime) {
      //   availabilityDataErrors.availabilityEndTime = 'Invalid end time';
      //   availabilityDataArrayErrors[index] = availabilityDataErrors;
      // }
      return availabilityDataErrors;
    });

    if (availabilityDataArrayErrors.length) {
      error.availabilityData = availabilityDataArrayErrors;
    }
  }
  if (values.unavailabilityData && values.unavailabilityData.length) {

    const unavailabilityDataArrayErrors = [];
    values.unavailabilityData.forEach((data, index) => {
      const unavailabilityDataErrors = {};
      // if (!data.unavailabilityStartTime && data.unavailabilityDate) {
      //   unavailabilityDataErrors.unavailabilityStartTime = 'Please select start time';
      //   unavailabilityDataArrayErrors[index] = unavailabilityDataErrors;
      // }
      // if (!data.unavailabilityEndTime && data.unavailabilityDate) {
      //   unavailabilityDataErrors.unavailabilityEndTime = 'Please select end time';
      //   unavailabilityDataArrayErrors[index] = unavailabilityDataErrors;
      // }
      // if (data.unavailabilityEndTime && data.unavailabilityStartTime && data.unavailabilityEndTime <= data.unavailabilityStartTime) {
      //   unavailabilityDataErrors.unavailabilityEndTime = 'Invalid end time';
      //   unavailabilityDataArrayErrors[index] = unavailabilityDataErrors;
      // }
      return unavailabilityDataErrors;
    });

    if (unavailabilityDataArrayErrors.length) {
      error.unavailabilityData = unavailabilityDataArrayErrors;
    }
  }
  if (!values.taxonomyCodeIds || values.taxonomyCodeIds === undefined) {
    error.taxonomyCodeIds = 'Please select taxonomy code';
  }


  /* else if (!Number.isInteger(values.Phone)) {
    error.Phone = 'Incorrect phone';
  }*/
  return error;
};

export default validate;



// WEBPACK FOOTER //
// ./src/modules/users/User/validate.js